"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Basic usage",
    value: '右侧的图标就是 colorIcon',
    allowClear: true
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorIcon', 'colorIconHover'],
  key: 'clearIcon'
};
var _default = exports.default = componentDemo;